import { useEffect, useState } from "react";
import { Filter } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";

import { ContainerHeader, FormFilterUsers, FormUser, UsersDataTable } from "@/components/common";
import { TeamSettingsLayout } from "../settings/team/team-settings-layout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useFetchUsersQuery, usePermission } from "@/hooks";
import { Skeleton } from "@/components/ui/skeleton";

export function Users() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { checkPermission } = usePermission();

  const [searchParams, setSearchParams] = useSearchParams();
  const page = searchParams.get("page");
  const roles = searchParams.get("roles");
  const account_type = searchParams.get("account_type");

  const perPageParam = searchParams.get("per_page");
  const [perPage, setPerPage] = useState<number>(
    perPageParam ? Number(perPageParam) : 10
  );
  const [search, setSearch] = useState<string>("");

  const {
    data: usersData,
    refetch: refetchUserData,
    isLoading,
  } = useFetchUsersQuery({ page, per_page: perPage, search, account_type, roles });

  const handlePerPageChange = (newPerPage: number) => {
    setPerPage(newPerPage);
    const newSearchParams = new URLSearchParams(searchParams.toString());
    newSearchParams.set("per_page", newPerPage.toString());
    setSearchParams(newSearchParams);
  };

  useEffect(() => {
    if (!checkPermission("user", "view user")) {
      navigate("/")
      return
    }
    setTimeout(async () => {
      await refetchUserData();
    }, 1500);
  }, [page, perPage, refetchUserData, search]);

  return (
    <TeamSettingsLayout current="users"
          actions={
            <FormUser>
              <Button
                variant="petrol"
                size="lg"
                className="px-5"
                disabled={!checkPermission("user", "create user")}
              >
                {t("LABEL.new")}
              </Button>
            </FormUser>
          }
    >
      <div className="space-y-5">
        <ContainerHeader>
          <Input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            type="search"
            aria-label="Pesquisar usuários"
            placeholder="Pesquisar"
            showError={false}
          />
          <FormFilterUsers>
            <Button variant="secondary" className="flex gap-2 items-center">
              <Filter className="size-3" aria-hidden="true" />
              <span>Filtrar</span>
            </Button>
          </FormFilterUsers>
        </ContainerHeader>
      </div>
      <div className="space-y-2">
        {!usersData || isLoading ? (
          <Skeleton className="w-full h-[500px]" />
        ) : (
          <UsersDataTable
            perPage={perPage}
            handlePerPageChange={handlePerPageChange}
            data={usersData}
          />
        )}
      </div>
    </TeamSettingsLayout>
  );
}
